import PropTypes from "prop-types"
import { Helmet } from "react-helmet-async"

import { Box } from "components/common"
import { jewlr_t } from "helpers/application"
import { SectionTitle } from "jewlr/pages/components"
import ImageTextBlock from "jewlr/pages/image-text-block"

import BestSellers from "./best-sellers"
import MainBanner from "./main-banner"
import OtherCollections from "./other-collections"
import SaleForHer from "./sale-for-her"
import SoMuchMore from "./so-much-more"

const CollectionsForHer = ({ userAgent }) => (
  <>
    <Helmet>
      <title>Collections For Her</title>
    </Helmet>
    <MainBanner />
    <Box contain>
      <Box mb={{ _: 4, desktop: 6 }} textAlign="center">
        <SectionTitle>She will LOVE these.</SectionTitle>
      </Box>
      {sl.config.sale_key.includes("mothers") ? (
        <>
          <ImageTextBlock
            element={{
              description: `A special keepsake that ${jewlr_t(
                "terms.Mom"
              )} will cherish forever.`,
              image: "collections-for-her/mothers-rings-wide",
              link: "/mothers-rings",
              title: "Mother's Rings",
            }}
          />
          <ImageTextBlock
            element={{
              description: "Keep loved ones close to her heart.",
              image: "collections-for-her/mothers-necklaces",
              link: `/necklaces-for-${jewlr_t("terms.mom")}`,
              title: "Mother's Necklaces",
            }}
          />
        </>
      ) : (
        <ImageTextBlock
          element={{
            description: `${jewlr_t(
              "terms.Personalize"
            )} a necklace with your name or theirs.`,
            image: "collections-for-her/name-necklaces-wide",
            link: "/name-necklaces",
            title: "Name Necklaces",
          }}
        />
      )}
      <ImageTextBlock
        element={{
          description: `${jewlr_t(
            "terms.Personalize"
          )} a ring as unique as your love.`,
          display: "flex",
          image: "collections-for-her/promise-rings",
          link: "/promise-rings-for-her",
          title: "Promise Rings",
        }}
      />
      {sl.config.sale_key.includes("mothers") ? (
        <ImageTextBlock
          element={{
            description: `${jewlr_t(
              "terms.Personalize"
            )} a necklace with your name or theirs.`,
            display: "flex",
            image: "collections-for-her/name-necklaces",
            link: "/name-necklaces",
            textPosition: "left",
            title: "Name Necklaces",
          }}
        />
      ) : (
        <ImageTextBlock
          element={{
            description: `A special keepsake that ${jewlr_t(
              "terms.Mom"
            )} will cherish forever.`,
            display: "flex",
            image: "collections-for-her/mothers-rings",
            link: "/mothers-rings",
            textPosition: "left",
            title: "Mother's Rings",
          }}
        />
      )}
      <ImageTextBlock
        element={{
          description: `${jewlr_t(
            "terms.Personalize"
          )} the ultimate symbol of love.`,
          image: "collections-for-her/engagement-rings",
          link: "/engagement-rings",
          title: "Engagement Rings",
        }}
      />
      {!sl.config.sale_key.includes("mothers") && (
        <ImageTextBlock
          element={{
            description: "Keep loved ones close to her heart.",
            image: "collections-for-her/mothers-necklaces",
            link: `/necklaces-for-${jewlr_t("terms.mom")}`,
            title: "Mother's Necklaces",
          }}
        />
      )}
      <Box mb={6}>
        <SoMuchMore />
      </Box>
      <SaleForHer />
      <BestSellers />
      <OtherCollections />
    </Box>
  </>
)

CollectionsForHer.propTypes = {
  userAgent: PropTypes.string,
}

export default CollectionsForHer
